var _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMap(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "23.682px",
    height: "19.865px",
    viewBox: "-0.23 2.058 23.682 19.865",
    enableBackground: "new -0.23 2.058 23.682 19.865",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1_1_"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_9_1_"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#808285",
    d: "M12.034,16.591c0.702,0,3.674-7.298,4.032-9.96c0.337-2.503-1.805-4.573-4.032-4.573 S7.648,4.131,8.001,6.631C8.378,9.291,11.361,16.591,12.034,16.591z"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "none",
    stroke: "#808285",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    points: " 22.952,21.423 0.27,21.423 6.669,11.762 17.797,11.762  "
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMap);
export default __webpack_public_path__ + "static/media/map.b154b49491430c07a6ccec5a45d7803f.svg";
export { ForwardRef as ReactComponent };